/* __next_internal_client_entry_do_not_use__ Filter auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";
import { FilterBar } from "@faire/retailer/components/Filters/FilterBar";
import { useFilterStore } from "@faire/retailer/components/Filters/useFilterStore";
import { FilterModal } from "./FilterModal/FilterModal";
var FilterBase = function(param) {
    var name = param.name, resultsCount = param.resultsCount, isLoading = param.isLoading, className = param.className, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky, _param_headerSeparator = param.headerSeparator, headerSeparator = _param_headerSeparator === void 0 ? false : _param_headerSeparator, PageActions = param.PageActions, children = param.children, _param_showUnformattedResultsCount = param.showUnformattedResultsCount, showUnformattedResultsCount = _param_showUnformattedResultsCount === void 0 ? false : _param_showUnformattedResultsCount;
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var _useFilterStore = useFilterStore([
        "isSideBarVisible"
    ]), isSideBarVisible = _useFilterStore.data.isSideBarVisible;
    return !isTabletAndBelow ? /*#__PURE__*/ _jsx(StyledFilterBar, {
        name: name,
        headerSeparator: headerSeparator,
        $isVisible: isSideBarVisible,
        isSticky: isSticky,
        isLoading: isLoading,
        className: className,
        PageActions: PageActions,
        showUnformattedResultsCount: showUnformattedResultsCount,
        children: children
    }) : /*#__PURE__*/ _jsx(FilterModal, {
        name: name,
        resultsCount: resultsCount,
        isLoading: isLoading,
        children: children
    });
};
export var Filter = observer(FilterBase);
var StyledFilterBar = styled(FilterBar).withConfig({
    componentId: "sc-cff89467-0"
})([
    "&&&{",
    "{display:none;}display:",
    ";height:100%;width:100%;max-width:228px;}"
], responsiveMediaQueries.tabletAndBelow, function(param) {
    var $isVisible = param.$isVisible;
    return $isVisible ? "flex" : "none";
});
